import utils from '@/mixins/utils.js'
import {
  getQuantidadeAcoes,
  getNomeColunaAcoes,
  getTipoAcao,
} from './functions.js'

function dadosExpandidosComoJson(item) {
  const d = item.dados
  if (d == null || d === '') return ''
  if (typeof d === 'string') return d
  try {
    return JSON.stringify(d)
  } catch {
    return ''
  }
}

/**
 * Monta os campos exportados para XLS.
 *
 * @param {Object|String|Number|null} mes Mês selecionado no filtro.
 * @param {Boolean} exibirEspecificas Indica se o filtro de específicas está ativo.
 * @param {Object|null} equipe Equipe selecionada.
 * @param {Boolean} exibirCompartilhadas Indica se o filtro de compartilhadas está ativo.
 * @returns {Object}
 */
export function getDataFields(
  mes = null,
  exibirEspecificas = false,
  equipe = null,
  exibirCompartilhadas = false
) {
  const tipoAcao = getTipoAcao(exibirEspecificas, exibirCompartilhadas)
  const colunaQuantidade = getNomeColunaAcoes(tipoAcao)

  return {
    Nome: {
      callback: (item) => item.no_cidadao?.trim() || '-',
    },

    'Data de nascimento': {
      callback: (item) =>
        item.dt_nascimento ? utils.methods.formatDate(item.dt_nascimento) : '-',
    },

    Mãe: {
      callback: (item) => item.no_mae?.trim() || '-',
    },

    [colunaQuantidade]: {
      callback: (item) => {
        return getQuantidadeAcoes(item, mes, tipoAcao, equipe)
      },
    },

    Dados: {
      callback: (item) => dadosExpandidosComoJson(item),
    },
  }
}
export const infoHtml = ``
